// A context telling consumers whether a sticky header is applied.
import { createContext } from "react";
const StickyHeaderContext = /*#__PURE__*/createContext();
export default StickyHeaderContext;